import { Pipe, PipeTransform, Injectable, inject } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Store } from '@ngrx/store';
import { COUNTRY_MASTER_STATE } from '@fitness-force/state';
import type { Country } from '@fitness-force/models';
import { CommonService } from '@fitness-force/api';
import { BehaviorSubject } from 'rxjs';
import { LOCALE_ID } from '@angular/core';


@Pipe({
  name: 'currencyformat',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyformatPipe implements PipeTransform {
  store = inject(Store);
  private commmonService = inject(CommonService);
  locale = inject(LOCALE_ID);

  currencyCode = new BehaviorSubject('');
  currencyName = new BehaviorSubject('');
  country!: Country;

  transform(
    value: number,
    convertFromMinorCurrency: boolean = true,
    digitsInfo?: string,
  ): string {
    this.store.select(COUNTRY_MASTER_STATE).subscribe((country: Country) => {
      if(country){
        this.currencyCode.next(country.currency_code);
        this.currencyName.next(country.currency_name);
        this.country = country;
      }
    });
    if (convertFromMinorCurrency) {
      value = this.commmonService.ConvertAmountFromMinorCurrency(value);
    }
    const currencyCode = this.country?.currency_code ?? this.currencyCode.value;
    const decimalPlaces = this.country?.miner_currency ?? this.commmonService.miner_currency.value;
    const digits = digitsInfo ?? this.commmonService.getCurrencyDigitsInfo(decimalPlaces);
    const symbol = getCurrencySymbol(this.currencyCode.value, 'narrow', this.locale);

    return formatCurrency(value, this.locale, symbol, currencyCode, digits);
  }
}


@Pipe({
  name: 'currencyformatByCurrencyCode',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyformatByCurrencyCodePipe implements PipeTransform {
  store = inject(Store);
  private commmonService = inject(CommonService);
  locale = inject(LOCALE_ID);

  country!: Country;

  transform(value: number, currencyCode: string, convertToMinorCurrency: boolean = true): string {
    if(currencyCode === '' || currencyCode === null || currencyCode === undefined){
      return '0.00';
    }

    this.store.select(COUNTRY_MASTER_STATE).subscribe((country: Country) => {
      if (country) this.country = country;
    });

    let amount = value;
    if(convertToMinorCurrency){
      amount = this.commmonService.getAmountFromMinorCurrencyAmount(amount, currencyCode);
    }

    const decimalPlaces = this.commmonService.getMinorCurrencyDecimalPlaces(currencyCode);
    const digits = this.commmonService.getCurrencyDigitsInfo(decimalPlaces);

    let symbol: string;
    if (this.country?.currency_code === currencyCode && this.country?.currency_symbol) {
      symbol = this.country.currency_symbol;
    } else {
      symbol = Intl.NumberFormat(this.locale, { style: 'currency', currency: currencyCode })
        .formatToParts()
        .find(part => part.type === 'currency')?.value || '';
    }

    return formatCurrency(amount, this.locale, symbol, currencyCode, digits);
  }
}


